import api from './api'

// Fetch the canonical list of retail chain slugs from the backend.
// Returns an array of slugs (e.g. ["plodine", "konzum", ...]).
export async function getChains() {
  const { data } = await api.get('/api/chains')
  return Array.isArray(data?.chains) ? data.chains : []
}
